import { render } from "./razorpayForm.vue?vue&type=template&id=1ccd60a6&scoped=true&ts=true"
import script from "./razorpayForm.vue?vue&type=script&lang=ts"
export * from "./razorpayForm.vue?vue&type=script&lang=ts"

import "./razorpayForm.vue?vue&type=style&index=0&id=1ccd60a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccd60a6"]])

export default __exports__